import React from 'react';
import PropTypes from 'prop-types';
import {connect} from "react-redux";
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import Fullscreen from 'material-ui/svg-icons/navigation/fullscreen';
import FileDownload from 'material-ui/svg-icons/file/file-download';
import FullscreenExit from 'material-ui/svg-icons/navigation/fullscreen-exit';
import IconMenu from 'material-ui/IconMenu';
import MenuItem from 'material-ui/MenuItem';
import IconButton from 'material-ui/IconButton';
import MoreVertIcon from 'material-ui/svg-icons/navigation/more-vert';
import ModeEdit from 'material-ui/svg-icons/editor/mode-edit';
import Terrain from 'material-ui/svg-icons/maps/terrain';
import {grey400} from 'material-ui/styles/colors';
import {Link} from "react-router-dom";
import {Paper, Snackbar, Subheader} from "material-ui";
import Dropzone from 'react-dropzone';
import ContentAdd from 'material-ui/svg-icons/content/add';
import {white} from "material-ui/styles/colors";
import styles from './TrailPage.css';
import AdminService, {ADMIN} from '../../../services/admin';
import {
    deleteTrail,
    fetchTrail,
    getTrail,
    postTrailGeojson,
    postTrailGpx,
    postTrailKml,
    postTrailMedia
} from "../../../store/trails/actions";
import Error from "../../../components/common/Error/Error";
import Loading from "../../../components/common/Loading/Loading";
import {fetchApp} from '../../../store/apps/actions';
import style from '../../../styles/styles';
import TrailInfo from "../../../components/openexplore/TrailInfo/TrailInfo";
import Mapbox from "../../../components/openexplore/Mapbox/Mapbox";
import MediaBlocs from "../../../components/media/MediaBlocs/MediaBlocs";
import TrailService from '../../../services/trail';
import DumbTypeList from "../../../components/type/DumbTypeList/DumbTypeList";
import {getTypes} from "../../../store/types/actions";
import {getCustomFields} from "../../../store/customfields/actions";
import CommentList from "../../../components/comment/CommentList/CommentList";
import {deleteComment} from "../../../store/comments/actions";
import ModuleService from '../../../services/module';
import withTranslation from "../../../hoc/withTranslation";
import {EDIT_TRAIL_PAGE, MIME_MEDIA_LIST_PAGE, OPENEXPLORE_PAGE} from "../../../constants/routes";
import { EXTERNAL } from '../../../constants/sources';
import ImportIndicator from '../../../components/import/ImportIndicator';
import CommentService from '../../../services/comment';

const iconButtonElement = (
    <IconButton
        touch={true}
        tooltipPosition="bottom-left"
    >
        <MoreVertIcon color={grey400} />
    </IconButton>
);

export class TrailPage extends React.Component {

    static supportedDropFiles = '.gpx, .kml, .geojson, .json';

    static propTypes = {
        app: PropTypes.object,
        trail: PropTypes.object
    };

    static defaultProps = {};

    state = {
        openRemoveTrail: false,
        snackbarError: null,
        uploadingFiles: [],
        commentToDelete: null,
        openDeleteComment: false,
        mapFullscreen: false
    };

    componentWillMount() {
        this.fetch();

        if (this.props.app) {
            this.props.getTypes(this.props.app.id, this.props.currentLang);
            this.props.getCustomFields(this.props.app.id);
        }
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.match !== nextProps.match || this.props.currentLang !== nextProps.currentLang) {
            this.fetch(nextProps.match.params.appId, nextProps.match.params.trailId, nextProps.currentLang);
        }
        if (this.props.sending && !nextProps.sending) {
            if (!nextProps.trail) { // Trail has been deleted
                this.props.history.push(OPENEXPLORE_PAGE.replace(':appId', this.props.app.id));
            }
        }

        if (this.props.commentSending && !nextProps.commentSending) {
            this.handleCloseDeleteComment();
            this.getTrail();
        }

        if (nextProps.app && this.props.app !== nextProps.app) {
            this.props.getTypes(nextProps.app.id, nextProps.currentLang);
            this.props.getCustomFields(nextProps.app.id);
        }
    }

    // Handlers

    handleDownloadGeolocationData = () => {
        if (this.props.trail) {
            TrailService.downloadGeolocationData(this.props.trail);
        }
    };

    handleAddGeolocationData = () => {
        this.dropzoneRef.open();
    };

    handleGeolocationDataDrop = (accepted, rejected) => {
        if (rejected.length > 0) {
            this.setState({
                snackbarError: this.props.t('medias.allowed_files', {
                    formats: "gpx, kml, geojson"
                })
            });

            return;
        }

        this.setState({uploadingFiles: []});

        accepted.forEach((file) => {
            console.log('Uploading file ' + file.name);

            let uploadMethod = null;

            if (file.name.endsWith('.gpx')) {
                uploadMethod = this.props.postTrailGpx;
            } else if (file.name.endsWith('.kml')) {
                uploadMethod = this.props.postTrailKml;
            } else if (file.name.endsWith('.json') || file.name.endsWith('.geojson')) {
                uploadMethod = this.props.postTrailGeojson;
            }

            if (uploadMethod) {
                uploadMethod(this.props.app.id, this.props.trail.id, file, this.props.currentLang, (progressEvent) => {
                    const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                    const uploadingState = this.state.uploadingFiles.filter((filePercent) => filePercent.file !== file);

                    console.log(file.name + ' -> ' + percentCompleted + '% (' + progressEvent.loaded + ' / ' + progressEvent.total + ')');

                    this.setState({
                        uploadingFiles: [
                            ...uploadingState,
                            {
                                file: file,
                                percent: percentCompleted
                            }
                        ]
                    });
                });
            }
        });
    };

    handleSnackbarClose = () => {
        this.setState({
            snackbarError: null
        });
    };

    // Delete trail

    handleOpenTrail = () => {
        this.setState({openRemoveTrail: true});
    };

    handleCloseTrail = () => {
        this.setState({openRemoveTrail: false});
    };

    deleteTrail = () => {
        this.props.deleteTrail(this.props.app.id, this.props.trail.id, this.props.currentLang);
    };

    selectMime = (mime) => {
        let url = MIME_MEDIA_LIST_PAGE
            .replace(':appId', this.props.app.id)
            .replace(':entityType', 'trails')
            .replace(':entityId', this.props.trail.id)
            .replace(':shortMime', mime);
        this.props.history.push(url);
    };

    // Delete comment

    handleDeleteComment = (comment) => {
        this.setState({
            openDeleteComment: true,
            commentToDelete: comment
        });
    };

    handleCloseDeleteComment = () => {
        this.setState({
            openDeleteComment: false,
            commentToDelete: null
        });
    };

    deleteComment = () => {
        this.props.deleteComment(this.props.app.id, this.state.commentToDelete.id);
    };

    switchFullScreen = () => {
        this.setState({
            mapFullscreen: !this.state.mapFullscreen
        })
    };

    // Fetch

    fetch(appId = null, trailId = null, lang = null) {
        this.fetchApplication(appId);
        this.fetchTrail(appId, trailId, lang);
    }

    fetchApplication(appId = null) {
        if (this.props.match) {
            const id = appId || this.props.match.params.appId;

            if (id) {
                this.props.fetchApp(id)
            }
        }
    }

    fetchTrail(appId = null, trailId = null, fetchLang = null) {
        if (this.props.match) {
            const app = appId || this.props.match.params.appId;
            const trail = trailId || this.props.match.params.trailId;
            const lang = fetchLang || this.props.currentLang;

            if (app && trail) {
                this.props.fetchTrail(app, trail, lang)
            }
        }
    }

    getTrail(appId = null, trailId = null) {
        if (this.props.match) {
            const app = appId || this.props.match.params.appId;
            const trail = trailId || this.props.match.params.trailId;

            if (app && trail) {
                this.props.getTrail(app, trail, this.props.currentLang)
            }
        }
    }

    // Render

    renderSnackbar() {
        return (<Snackbar
            open={this.state.snackbarError !== null}
            message={this.state.snackbarError || ''}
            action={this.props.t('generic.close')}
            bodyStyle={{height: 'auto', lineHeight: '28px', padding: 24, whiteSpace: 'pre-line'}}
            onActionTouchTap={this.handleSnackbarClose}
            onRequestClose={this.handleSnackbarClose}
            onActionClick={this.handleSnackbarClose} />)
    }

    renderMenu() {
        let menu;

        if (AdminService.isAuthorized(ADMIN, this.props.user)) {
            menu = (
                <IconMenu
                    style={styles.buttons}
                    iconButtonElement={iconButtonElement}
                    anchorOrigin={{horizontal: 'right', vertical: 'top'}}
                    targetOrigin={{horizontal: 'right', vertical: 'top'}}>
                    <Link
                        to={EDIT_TRAIL_PAGE.replace(':appId', this.props.app.id).replace(':trailId', this.props.trail.id)}>
                        <MenuItem>
                            {this.props.t('generic.edit')}
                        </MenuItem>
                    </Link>
                    <MenuItem onClick={this.handleOpenTrail}>
                        {this.props.t('generic.remove')}
                    </MenuItem>
                </IconMenu>
            );
        }

        return menu;
    };

    renderDeleteCommentDialog(comment) {
        let actions = [
            <FlatButton
                label={this.props.t('generic.cancel')}
                disabled={this.props.commentSending}
                onClick={this.handleCloseDeleteComment}
            />,
            <FlatButton
                label={this.props.t('generic.delete')}
                primary={true}
                disabled={this.props.commentSending}
                onClick={this.deleteComment}
            />
        ];
        const text = CommentService.getTextForComment(
            this.props.t,
            comment,
            'module.comment.delete_comment_confirmation'
        );
        return (
            <Dialog actions={actions}
                    title={this.props.t('module.comment.reject_comment')}
                    modal={this.props.commentSending}
                    open={this.state.openDeleteComment}
                    onRequestClose={this.handleCloseDeleteComment}>
                {this.props.commentSending && <Loading paper={false} />}
                {!this.props.commentSending &&
                    <span>
                        <div dangerouslySetInnerHTML={{ __html: text }} />
                    </span>
                }
            </Dialog>
        );
    }

    renderDeleteTrailDialog() {
        let actions = [
            <FlatButton
                label={this.props.t('generic.cancel')}
                disabled={this.props.sending}
                onClick={this.handleCloseTrail}
            />,
            <FlatButton
                label={this.props.t('generic.delete')}
                primary={true}
                disabled={this.props.sending}
                onClick={this.deleteTrail}
            />
        ];

        return (
            <Dialog
                actions={actions}
                modal={false}
                open={this.state.openRemoveTrail}
                onRequestClose={this.handleCloseTrail}
            >
                {this.props.sending && <Loading paper={false} />}
                {!this.props.sending &&
                    <p>{this.props.t('module.open_explore.delete_trail_confirmation')}</p>
                }
            </Dialog>
        );
    }

    renderMap() {
        return (
            <div style={style.col} className="col-xs-12 col-sm-12 col-md-12">
                <Paper>
                    <Subheader style={{...style.subHeader, ...style.relative}}>
                        {this.props.t('generic.map')}
                        <IconButton
                            style={styles.rightIcon.third}
                            tooltip={this.props.t('module.open_explore.download_geolocation_data')}
                            tooltipPosition='top-left'
                            onClick={this.handleDownloadGeolocationData}
                        >
                            <FileDownload color={white} />
                        </IconButton>
                        <IconButton
                            style={styles.rightIcon.second}
                            tooltip={this.props.t('module.open_explore.update_geolocation_data')}
                            tooltipPosition='top-left'
                            onClick={this.handleAddGeolocationData}
                        >
                            <ModeEdit color={white} />
                        </IconButton>
                        <IconButton
                            style={styles.rightIcon.first}
                            tooltip={this.props.t('module.open_explore.map_fullscreen')}
                            tooltipPosition='top-left'
                            onClick={this.switchFullScreen}
                        >
                            {this.state.mapFullscreen ?
                                <FullscreenExit color={white} />
                                :
                                <Fullscreen color={white} />
                            }
                        </IconButton>
                    </Subheader>
                    <Mapbox
                        scrollWheelZoom={false}
                        canShowDetail={false}
                        points={[]}
                        trails={this.props.trails}
                        style={this.state.mapFullscreen ? styles.mapFull : styles.map}
                        mapStyle={this.props.mapStyle}
                    />
                </Paper>
            </div>
        );
    }

    renderInfo() {
        return (
            <div style={style.col} className="col-xs-12 col-sm-12 col-md-12">
                <TrailInfo
                    trail={this.props.trail}
                    customFields={this.props.customFields}
                    app={this.props.app}
                    lang={this.props.currentLang}
                />
            </div>
        );
    }

    renderTypes() {
        const types = this.props.types.filter((type) => {
            return this.props.trail.types_id.includes(type.id);
        });

        return (
            <div style={style.col} className="col-xs-12 col-sm-12 col-md-12">
                <DumbTypeList
                    title={this.props.t('generic.types')}
                    types={types}
                    loading={this.props.typesPending}
                />
            </div>
        );
    }

    renderMedias() {
        return (
            <div style={style.col} className="col-xs-12 col-sm-12 col-md-12">
                <MediaBlocs
                    app={this.props.app}
                    entity={this.props.trail}
                    medias={this.props.trail.medias || []}
                    pendingMedias={this.props.pendingMedias}
                    postMedia={this.props.postTrailMedia}
                    selectMime={this.selectMime}
                    uploadedMedias={this.props.uploadedMedias}
                    failedMedias={this.props.failedMedias}
                    currentLang={this.props.currentLang}
                />
            </div>
        );
    }

    renderDropzone() {
        return (
            <div
                style={{
                    ...style.col,
                    display: TrailService.hasGeolocationData(this.props.trail) ? 'none' : 'block'
                }}
                className="col-xs-12 col-sm-12 col-md-12"
            >
                <Paper>
                    <Subheader style={{...style.subHeader, ...style.relative}}>
                        {this.props.t('module.open_explore.geolocation_data')}
                        <IconButton
                            style={styles.rightIcon.first}
                            tooltip={this.props.t('module.open_explore.new_geolocation_data')}
                            tooltipPosition='bottom-left'
                            onClick={this.handleAddGeolocationData}
                        >
                            <ContentAdd color={white} />
                        </IconButton>
                    </Subheader>

                    <div style={style.paper}>
                        <Dropzone
                            ref={(node) => {
                                this.dropzoneRef = node
                            }}
                            style={styles.dropzone.container}
                            accept={TrailPage.supportedDropFiles}
                            onDrop={this.handleGeolocationDataDrop}
                            multiple={false}
                        >
                            <div style={styles.dropzone.title}>
                                Drop your geolocation file here
                            </div>
                            <div style={styles.dropzone.subtitle}>
                                {TrailPage.supportedDropFiles}
                            </div>
                            <br />
                            <Terrain />
                        </Dropzone>
                    </div>
                </Paper>
            </div>
        );
    }

    renderComment() {
        return (
            <div style={style.col} className="col-xs-12 col-sm-12 col-md-12">
                <CommentList
                    title={this.props.t('generic.comments')}
                    user={this.props.user}
                    comments={this.props.trail.comments}
                    handleDeleteComment={this.handleDeleteComment}
                />
            </div>

        );
    }

    render() {
        if (this.props.error) {
            return (
                <Error
                    title={this.props.t('generic.error')}
                    subtitle={this.props.t('generic.error_loading')}
                    paper={true}
                />
            );
        } else if (this.props.loading || !this.props.app || !this.props.trail) {
            return <Loading paper={false} />;
        } else {
            return (
                <div style={styles.container}>
                    {this.renderSnackbar()}
                    {this.props.trail.source === EXTERNAL ? <ImportIndicator />: null}
                    {this.renderMenu()}
                    {this.renderDeleteTrailDialog()}
                    {this.state.commentToDelete && this.renderDeleteCommentDialog(this.state.commentToDelete)}

                    <h3 style={style.navigation}>{this.props.t('module.open_explore.trail')} / {this.props.t('generic.detail')} - {this.props.trail.name}</h3>
                    <div className="row">
                        {TrailService.hasGeolocationData(this.props.trail) && this.renderMap()}
                        {this.renderDropzone()}
                        {this.renderInfo()}
                        {this.renderTypes()}
                        {this.renderMedias()}
                        {ModuleService.hasModule(this.props.app, ModuleService.COMMENTS) && this.renderComment()}
                    </div>
                </div>
            )
        }
    }
}

function mapStateToProps(state, ownProps) {
    let props = {
        mapStyle: state.ui.mapStyle,
        error: state.apps.error || state.trails.error,
        user: state.auth.content,
        loading: state.apps.pending || state.trails.pending || state.customFields.pending || state.types.pending,
        sending: state.trails.sending,
        trail: state.trails.currentTrail,
        currentLang: state.ui.currentLang,
        app: state.apps.currentApplication,
        pendingMedias: state.trails.pendingMedias,
        uploadedMedias: state.trails.uploadedMedias,
        failedMedias: state.trails.failedMedias,
        currentMedia: state.trails.currentMedia,
        types: state.types.content,
        typesPending: state.types.pending,
        commentSending: state.comments.sending,
        customFields: state.customFields.content
    };

    props.trails = [props.trail];

    return props;
}

export default connect(mapStateToProps, {
    postTrailKml,
    postTrailGeojson,
    postTrailGpx,
    postTrailMedia,
    fetchApp,
    getTrail,
    fetchTrail,
    deleteTrail,
    getTypes,
    getCustomFields,
    deleteComment
})(withTranslation(TrailPage));



// WEBPACK FOOTER //
// src/containers/openexplore/TrailPage/TrailPage.js